import GenderToggles from './GenderToggles';
export default GenderToggles;
